<template>
    <div v-if="flds" class="row g-3 p-3 shadow justify-content-center bg-white border-20">
      <header class="row w-100 header justify-content-center py-3">
            <div class="col-12 col-md-12 col-xl-4 col-lg-4 mb-2 mb-md-2 mb-xl-0 mb-lg-0">
              <router-link :to="'/ai/writing'">
                <div class="d-flex align-items-center justify-content-center border-20 hedaeritem active">
                    دریافت موضوع از سیستم
                </div>
              </router-link>  
            </div>
            <div class="col-12 col-md-12 col-xl-4 col-lg-4 mb-2 mb-md-2 mb-xl-0 mb-lg-0">
              <router-link :to="'/ai/customwriting'">
                <div class="d-flex align-items-center justify-content-center border-20 hedaeritem">
                  ایجاد موضوع دلخواه
                </div>
              </router-link>  
            </div>
            
            <div class="col-12 col-md-12 col-xl-4 col-lg-4">
              <router-link :to="'/ai/writing/list'">
                <div class="d-flex align-items-center justify-content-center border-20 hedaeritem">
                  فهرست آزمون های انجام شده
                </div>
              </router-link>
            </div>
        </header>
        <div class="col-12"><p class="para mt-3 text-center">در این قسمت می‌توانید برای امتحان آیلتس موضوع تمرین نوشتاری (Writing) دریافت کنید.</p></div>
        <div class="col-12"><p class="para mt-1 text-center">سیستم هوشمند ما پس از ارائه موضوع و مشخص‌نمودن تکلیف، به پاسخ‌های شما نمره خواهد داد.</p></div>        
        <div class="col-12">
            <div class="w-100 d-flex align-items-center justify-content-center mt-3">
                <div class="d-flex align-items-center justify-content-center addtopic">ایجاد موضوع توسط سیستم</div>
            </div>
        </div>
        <div class="col-12">
            <div class="w-100 d-flex align-items-start flex-wrap mt-3">
              <div class="col-12 col-md-12 col-xl-2 col-lg-2 mt-2 mt-md-2 mt-xl-0 mt-lg-0 d-flex align-items-center justify-content-center justify-content-md-center justify-content-lg-end justify-content-xl-end order-2 order-md-2 order-xl-1 order-lg-1">
                <span class=" d-flex align-items-center justify-content-center savetopic">
                  تایید شده
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M15.6209 9.40499C15.9213 9.70539 15.9213 10.1924 15.6209 10.4928L11.5183 14.5954C11.2179 14.8958 10.7308 14.8958 10.4304 14.5954L8.37917 12.5441C8.07877 12.2437 8.07877 11.7567 8.37917 11.4563C8.67957 11.1559 9.16662 11.1559 9.46703 11.4563L10.9744 12.9636L14.533 9.40499C14.8334 9.10459 15.3204 9.10459 15.6209 9.40499Z" fill="#1b60c6"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 3.53846C7.32682 3.53846 3.53846 7.32682 3.53846 12C3.53846 16.6732 7.32682 20.4615 12 20.4615C16.6732 20.4615 20.4615 16.6732 20.4615 12C20.4615 7.32682 16.6732 3.53846 12 3.53846ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z" fill="#1b60c6"/>
                  </svg>
                </span>
              </div>
                <div name="topic" id="topic" class="col-12 col-md-12 col-xl-10 col-lg-10 textarea text-left p-2 topic d-flex order-1 order-md-1 order-xl-2 order-lg-2" ></div>
              </div>
            </div>
            
            <div  class="col-12">
              <div class="w-100 d-flex align-items-start flex-wrap mt-3">
              <div  id="topic7" class="w-100 textarea text-left bg-white p-2 topic7"></div>
              <textarea @input="updateTheVariable($event.target.value)" name="topic2" rows="7" id="topic2" class="w-100 textarea text-left bg-white p-2" placeholder="Write your answer here ..."></textarea>
    
              <div v-if="!data" class="w-100 d-flex align-items-center justify-content-between mt-3">
                <span v-if="!data" id="alertsendresponse" class="alertsendresponse"></span>
                <span v-else ></span>
                <span @click="sav()" id="sendresponse" class="d-flex align-items-center justify-content-center sendresponse">
                  ارسال پاسخ
                </span>
              </div> 
            </div>
        </div>
        <div v-if="data" class="col-12">
            <div class="w-100 d-flex align-items-start flex-wrap mt-4">
                <header class="w-100 responsehedaer mb-3 pb-3">
                  <h3 class="m-0">نتیجه تصحیح تمرین نوشتاری (Writing)</h3>
                </header>
                <div name="topic" id="topic3" class="w-100 textarea text-left p-2" placeholder="Your topic will be displayed here">
                  <ul class="w-100 d-flex flex-wrap justify-content-start m-0 p-2">
                    <li class="text-left d-flex align-items-center flex-wrap mb-4 responseitem">
                      <div class="w-100 d-flex align-items-center justify-content-start mb-1 text-left"><span>TaskAchievement :</span> <span class="ml-2">{{ data.TaskAchievementScore }}</span></div>
                      <p class="text-left">{{ data.TaskAchievementExplanation }}</p>
                    </li>
                    <li class="text-left d-flex align-items-center flex-wrap mb-4 responseitem">
                      <div class="w-100 d-flex align-items-center justify-content-start mb-1 text-left"><span>CoherenceCohesion :</span> <span class="ml-2">{{ data.CoherenceCohesionScore }}</span></div>
                      <p class="text-left">{{ data.CoherenceCohesionExplanation }}</p>
                    </li>
                    <li class="text-left d-flex align-items-center flex-wrap mb-4 responseitem">
                      <div class="w-100 d-flex align-items-center justify-content-start mb-1 text-left"><span>LexicalResource :</span> <span class="ml-2">{{ data.LexicalResourceScore }}</span></div>
                      <p class="text-left">{{ data.LexicalResourceExplanation }}</p>
                    </li> 
                    <li class="text-left d-flex align-items-center flex-wrap mb-4 responseitem">
                      <div class="w-100 d-flex align-items-center justify-content-start mb-1 text-left"><span>GrammaticalRangeAccuracy :</span> <span class="ml-2">{{ data.GrammaticalRangeAccuracyScore }}</span></div>
                      <p class="text-left">{{ data.GrammaticalRangeAccuracyExplanation }}</p>
                    </li>
                    <li class="text-left d-flex align-items-center flex-wrap mt-4 responseitem">
                      <div class="w-100 d-flex align-items-center justify-content-start text-left"><span>Overall :</span> <span class="ml-2">{{ data.OverallScore }}</span> </div>
                    </li>
                  </ul>
                </div>
            </div>
        </div>
        <div v-if="data" class="col-12">
            <div class="w-100 d-flex align-items-start justify-content-center flex-wrap mt-4">
                <header class="w-100 responsehedaer mb-3 pb-3">
                  <h3 class="m-0">بازنویسی پاسخ</h3>
                </header>
              <div class="w-100 d-flex align-items-center justify-content-between mb-3">
                <div class="d-flex algin-items-center">
                  <selectInput
                    @inputTxtFunc = "(e)=>{score = e;}"
                    :value = "score"
                    label="نمره موردنظر خود را انتخاب کنید"
                    :flds="[
                      {'id': '6', 'name': 'نمره ی 6'},
                      {'id': '6.5', 'name': 'نمره ی 6.5'},
                      {'id': '7', 'name': 'نمره ی 7'},
                      {'id': '7.5', 'name': 'نمره ی 7.5'},
                      {'id': '8', 'name': 'نمره ی 8'},
                    ]"
                  />
                </div>
                <span @click="sav2()" class="d-flex align-items-center justify-content-center sendscore">
                  بازنویسی پاسخ
                </span>
              </div>
              <div name="topic4" id="topic4" class="w-100 textarea text-left p-2" placeholder="Your revision will be displayed here.">Your revision will be displayed here.</div>
              <div class="row w-100 mt-3">
                <div class="col-12 col-md-12 col-xl-6 col-lg-6 mb-2 mb-md-2 mb-xl-0 mb-lg-0">
                  <router-link :to="'/ai/writing/list'">
                    <div class="w-100 d-flex align-items-center justify-content-center btnback white">پایان و مشاهده لیست آزمون های قبلی</div>
                  </router-link>
                  
                </div>
                <div class="col-12 col-md-12 col-xl-6 col-lg-6">
                  <router-link :to="'/ai/writing'">
                    <div class="w-100 d-flex align-items-center justify-content-center btnback green">پایان و شروع آزمون جدید</div>
                  </router-link>
                </div>
              </div>
            </div>
        </div>
    </div>
    </template>
  
  <script>
  import btn from "../../../../UI/button/btn.vue";
  import textInput from "../../../../UI/input/textInput.vue";
  import selectInput from "../../../../UI/input/selectInput.vue";
  import userImg from "../../../../UI/userImg/userImg.vue";
  import pageNavigation from "../../../../UI/pageNavigation/pageNavigation.vue";
  import previewImage from "../../../../UI/uploadFile/previewImage.vue";
  import { indexFinder } from "../../../../assets/library/filter.js";
  
  export default {
    name: "self_part1",
    data() {
      return {
        imgurl: window.imgurl,
        baseurl: window.baseurl,
        location: { ok: false, data: [] },
        degrees: { ok: false, data: [] },
        field: { ok: false, data: [] },
        category: { ok: false, data: [] },
        flds: {ok: false, data: []},
        topic: '',
        variable: '',
        data: '',
        score:'',
        writing:'',
        username: [],
        indexFinder: indexFinder,
        val: {
          lP: "",
          lC: "",
          d: "",
          c: "",
          f: "",
          e: "",
        },
      };
    },
    components: {
      btn,
      textInput,
      selectInput,
      pageNavigation,
      userImg,
      previewImage,
    },
    props: {
      flds: {
        default: [],
      },
    },
    mounted() {
      this.getLocation();
      this.crmslist();
    },
    methods: {
      updateTheVariable(value){
        this.variable = value
    },
      getLocation(THIS = this) {
        window.$.get(
          this.baseurl + "location/list",
          {},
          function (D) {
            THIS.location = D;
            THIS.getField();
          },
          "json"
        );
      },
      
      getField(THIS = this) {
        window.$.get(
          this.baseurl + "field/list",
          {},
          function (D) {
            THIS.field = D;
          },
          "json"
        );
      },
      //**********************************************************************
      crmslist( THIS = this) {
				// if(this.$localStorage.get("user").username.role == 3) {
					window.$.post(this.baseurl+"ai/selecttopic", {
						writing_id: this.$route.params.id
					}, function(D) {
						if(D.data) {
							THIS.flds = {ok: true, data: D.data};
							THIS.topic = D.data[0].topic;
              document.getElementById('topic').innerHTML =  D.data[0].topic.replace(/\\n/g, '<br />');
              if(D.data[0].writing){
                document.getElementById('topic7').innerHTML =  D.data[0].writing.replace(/\\n/g, '<br />');
                THIS.variable = D.data[0].writing;
                THIS.writing = D.data[0].writing;
                document.getElementById('topic2').style =  'display:none;';
                document.getElementById('sendresponse').style =  'display:none !important;';
              } else {
                document.getElementById('topic7').style =  'display:none;';
              }
              // console.log('sddd',D.data[0].data.length);
              if(D.data[0].data.length > 2){
                THIS.data = JSON.parse(D.data[0].data)
              }
       
						}
					
					}, "json");
				// }
			},
      //**********************************************************************
      sav(THIS = this) {
        const formdata = new FormData();
        formdata.append("topic", THIS.topic);
        formdata.append("writing",  THIS.variable);
        formdata.append("topicid",  THIS.$route.params.id);


        const requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow"
        };

        document.getElementById('alertsendresponse').innerText = 'لطفا برای دریافت نمره آزمون صبر کنید...';

        fetch(THIS.baseurl + "ai/correction", requestOptions)
        .then((response) =>  response.json())
        .then((result) => {
          console.log('result', result );
          THIS.data = result.data
          document.getElementById('topic3').innerHTML = result.data.replace(/\\n/g, '<br />')
          document.getElementById('topic3').style.height = 'auto';
          document.getElementById('alertsendresponse').innerHTML = '';
        })
        .catch((error) => console.error(error));
      },
      //**********************************************************************
      sav2(THIS = this) {
        const formdata = new FormData();
        formdata.append("topic", THIS.topic);
        formdata.append("writing",  THIS.variable);
        formdata.append("score",  THIS.score);


        const requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow"
        };
        fetch(THIS.baseurl + "ai/revision", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          document.getElementById('topic4').innerHTML = result.data.replace(/\\n/g, '<br />')
          document.getElementById('topic4').style.height = 'auto';
        })
        .catch((error) => console.error(error));
      },
    },
  };
  </script>
  <style>
  .border-20 {
    border-radius: 20px;
  }
  
  .headerai > h4 {
    font-size: 14px;
    font-weight: 400 !important;
    color: #000;
  }
  
  .ai-item {
    height: 240px;
    border: 2px solid #eee7d0;
    cursor: pointer;
    box-shadow: 0;
    transition: 0.3s ease-in-out;
  }
  
  .ai-item:hover {
    box-shadow: 0px 4px 4px 0px #00000040;
    background-color: #fffcf8 !important;
    transition: 0.3s ease-in-out;
  }
  
  .ai-item  header  h3 {
    color: #000;
    font-size: 14px;
    font-weight: 800;
  }
  
  .ai-item.disable  header  h3 {
    color: #676767;
  }
  .hedaeritem {
    height: 72px;
    background-color: #F0F0F0;
    font-size: 14px;
    font-weight: 800;
    color: #808285;
  }
  
  .hedaeritem.active {
    background-color: #FFF7E9;
    box-shadow: 0px 4px 4px 0px #00000040;
    color: #000;
  }

  .header {
    border-bottom: 1px solid #D1D3D4;
  }
  .para {
    font-size: 11px;
    color: #000;
  }
  .addtopic {
    border-radius: 10px;
    width: 278px;
    height: 44px;
    font-size: 12px;
    font-weight: 800;
    background-color: #E6E7E8 !important;
    color: #808285 !important;
  }
  .savetopic {
    border: 1px solid #C6C6C6;
    height: 60px;
    width: 104px;
    background-color: #F5FAFD;
    font-size: 14px;
    color: #676767;
    border-radius: 10px;
  }

  .textarea {
    height: auto;
    border: 1px solid #C6C6C6;
    background-color: #F5FAFD;
    font-size: 14px;
    color: #676767;
    border-radius: 10px;
    direction: ltr;
  }
  .sendresponse {
    height: 44px;
    width: 180px;
    background-color: #1b60c6;
    border-radius: 10px;
    color: #fff;
    font-size: 12px;
    cursor: pointer;
  }
  .responseitem span {
    color: #1b60c6;
    font-family: 'IRANYekanBlack';
    font-size: 14px;
    font-weight: 800;
  }

  .responseitem p {
    color: #676767;
    font-size: 14px;
    direction: ltr;

  }

  .responsehedaer h3 {
    color: #000;
    font-size: 14px;
    font-weight: 800;
  }

  .responsehedaer {
    border-bottom: 1px solid #D1D3D4;
  }
  .alertsendresponse {
    font-size: 14px;
    color: #AA000C;
  }

  .btnback {
    height: 44px;
    border-radius: 10px;
  }

  .btnback.white {
    font-size: 12px;
    color: #1b60c6;
    border: 1px solid #1b60c6;
    cursor: pointer;
  }
  .btnback.green {
    font-size: 12px;
    color: #fff;
    border: 1px solid #1b60c6;
    background-color:#1b60c6;
    cursor: pointer;
  }

  .sendscore {
    font-size: 12px;
    width: 180px;
    height: 44px;
    border-radius: 10px;
    color: #000;
    background-color: #FAA61A;
    cursor: pointer;
  }
  </style>